module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fullmenu",
    style: (_vm.menuPaddingTop ? 'padding-top: ' + _vm.menuPaddingTop + 'px' : '')
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2 order-sm-2 col-lg order-lg-1"
  }, [_c('h3', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v(_vm._s(_vm.$t('$menu.language.name')))]), _c('div', {
    staticClass: "links"
  }, [_c('div', [_c('a', {
    staticClass: "menu",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.changeLanguage
    }
  }, [_vm._v(_vm._s(_vm.$t('$menu.language.other')))])])])]), _vm._l((_vm.menu), function(link, key) {
    return _c('div', {
      staticClass: "col-6 col-sm-2 col-lg",
      class: [link.display, link.order]
    }, [_c('h3', [(_vm.$store.state.links[key].url) ? [_c('router-link', {
      staticClass: "menu grey",
      attrs: {
        "to": _vm.$store.state.links[key].url
      },
      nativeOn: {
        "click": function($event) {
          _vm.close($event)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t(_vm.$store.state.links[key].name)))])] : [_vm._v(_vm._s(_vm.$t(_vm.$store.state.links[key].name)))]], 2), _c('div', {
      staticClass: "links"
    }, _vm._l((_vm.$store.state.links[key].sublinks), function(sublink) {
      return _c('div', [(_vm.$store.state.links[key].blank) ? _c('a', {
        staticClass: "menu",
        attrs: {
          "href": sublink.url,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(sublink.name))]) : (sublink.id) ? _c('router-link', {
        staticClass: "menu",
        attrs: {
          "to": sublink.url
        },
        nativeOn: {
          "click": function($event) {
            _vm.close($event)
          }
        }
      }, [_vm._v(_vm._s(sublink.name[_vm.$i18n.locale]))]) : _c('router-link', {
        staticClass: "menu",
        attrs: {
          "to": sublink.url
        },
        nativeOn: {
          "click": function($event) {
            _vm.close($event)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t(sublink.name)))])], 1)
    }))])
  })], 2), _c('div', {
    staticClass: "language-switch"
  }, [_c('a', {
    staticClass: "menu",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.changeLanguage
    }
  }, [_vm._v(_vm._s(_vm.$t('$menu.language.other')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bde6c50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/FullMenu.vue
// module id = 45
// module chunks = 7